<template>
  <categoryLayout template-type="trash">
    <Categories mode="trash" :categories="categories"/>
  </categoryLayout>
</template>
<script>
import {mapGetters} from "vuex";
import categoryLayout from "./layout";
import Categories from "./categories";

export default {
  name: "TrashCategoryItems",
  components: {Categories, categoryLayout},
  computed: {
    ...mapGetters({
      categories: "Category/getFilteredCategories",
    }),
  },
  async mounted() {
    this.$store.commit("Category/setCategories", {});
    this.$store.commit("Category/setFilteredCategories", {});

    await this.$store.dispatch("Category/getTrashCategories");
  },
};
</script>
<style scoped>
</style>